/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Parameters required to create new Bronze id Workflow
 * @export
 * @interface InvestigationRequestDto
 */
export interface InvestigationRequestDto {
    /**
     * Name of AID of credentials Issuer
     * @type {string}
     * @memberof InvestigationRequestDto
     */
    issuerName: string;
    /**
     * SAID of the bronze id schema
     * @type {string}
     * @memberof InvestigationRequestDto
     */
    schemaId: string;
    /**
     * AID prefix of the Issuee
     * @type {string}
     * @memberof InvestigationRequestDto
     */
    recipient: string;
    /**
     * captcha token
     * @type {string}
     * @memberof InvestigationRequestDto
     */
    token: string;
    /**
     * JSON object of rules OR simple string
     * @type {object}
     * @memberof InvestigationRequestDto
     */
    rules: object;
    /**
     * 
     * @type {number}
     * @memberof InvestigationRequestDto
     */
    loa: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvestigationRequestDto
     */
    lids: Array<string>;
    /**
     * OOBI for the issuing credentials
     * @type {string}
     * @memberof InvestigationRequestDto
     */
    oobi: string;
    /**
     * Alias for the issuing credentials
     * @type {string}
     * @memberof InvestigationRequestDto
     */
    alias: string;
    /**
     * JSON object of source
     * @type {object}
     * @memberof InvestigationRequestDto
     */
    source?: object;
}

/**
 * Check if a given object implements the InvestigationRequestDto interface.
 */
export function instanceOfInvestigationRequestDto(value: object): boolean {
    if (!('issuerName' in value)) return false;
    if (!('schemaId' in value)) return false;
    if (!('recipient' in value)) return false;
    if (!('token' in value)) return false;
    if (!('rules' in value)) return false;
    if (!('loa' in value)) return false;
    if (!('lids' in value)) return false;
    if (!('oobi' in value)) return false;
    if (!('alias' in value)) return false;
    return true;
}

export function InvestigationRequestDtoFromJSON(json: any): InvestigationRequestDto {
    return InvestigationRequestDtoFromJSONTyped(json, false);
}

export function InvestigationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestigationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'issuerName': json['issuerName'],
        'schemaId': json['schemaId'],
        'recipient': json['recipient'],
        'token': json['token'],
        'rules': json['rules'],
        'loa': json['loa'],
        'lids': json['lids'],
        'oobi': json['oobi'],
        'alias': json['alias'],
        'source': json['source'] == null ? undefined : json['source'],
    };
}

export function InvestigationRequestDtoToJSON(value?: InvestigationRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'issuerName': value['issuerName'],
        'schemaId': value['schemaId'],
        'recipient': value['recipient'],
        'token': value['token'],
        'rules': value['rules'],
        'loa': value['loa'],
        'lids': value['lids'],
        'oobi': value['oobi'],
        'alias': value['alias'],
        'source': value['source'],
    };
}

